import { ViewModel } from "../CoreTypes";

export type LeafValue = string;
export type Path = string;

export interface NodeViewModel {
    [key: string]: NodeViewModel | ViewModel;
}

export interface FormViewModel {
    [key: string]: NodeViewModel;
}

export function getViewModel(nodeViewModel: NodeViewModel): undefined | ViewModel {
    return nodeViewModel["."];
}

export function getNestedNodeViewModels(nodeViewModel: NodeViewModel): Array<[string, NodeViewModel]> {
    // @ts-ignore
    return Object.entries(nodeViewModel).filter(x => x[0] !== ".");
}
